var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fetcher } from "@/api/schema";
export const datatypesFetcher = fetcher.path("/api/datatypes").method("get").create();
export const edamFormatsFetcher = fetcher.path("/api/datatypes/edam_formats/detailed").method("get").create();
export const edamDataFetcher = fetcher.path("/api/datatypes/edam_data/detailed").method("get").create();
const typesAndMappingsFetcher = fetcher.path("/api/datatypes/types_and_mapping").method("get").create();
export function fetchDatatypesAndMappings(upload_only = true) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield typesAndMappingsFetcher({ upload_only });
        return data;
    });
}
